<template>
    <v-container>
        <v-skeleton-loader loading v-if="!readyToRender"
                           class="mx-auto"
                           type="image"></v-skeleton-loader>
        <v-card max-width="1200" v-if="readyToRender" :class="{ 'mx-auto': !margin && !screenshot }" class="rounded-lg ts-nft" id="screenshot-1" elevation="24">
            <span class="text-h1">{{ position }}</span>
            <v-list-item three-line>
                <v-list-item-content>
                    <v-container fluid>
                        <v-row>
                            <v-col class="pt-0 ml-1 mt-1" md="auto">
                                <v-sheet class="rounded-lg" elevation="4" :outlined="color === '#000000' ? true : false" :height="$vuetify.breakpoint.mobile ? 40 : 30" :width="$vuetify.breakpoint.mobile ? 40 : 30" :color="color"></v-sheet>
                            </v-col>
                            <v-col class="text-no-wrap font-italic">
                                <span class="text-h6 font-weight-medium">{{ nft.bra.brand }} </span>
                                <span class="text-h6 font-weight-light">{{ nft.bra.name }} </span>
                                <span class="text-h6 font-weight-bold">{{ nft.bra.size.band }}</span>
                                <span class="text-h6 font-weight-bold text-uppercase">{{ nft.bra.size.cup }}</span>
                            </v-col>
                            <v-spacer v-if="!screenshot"></v-spacer>
                        </v-row>
                    </v-container>
                    <v-container>
                        <v-row>
                            <v-col style="line-height: unset">
                                <div class="mb-4 text-caption">
                                    <div class="mt-n2" v-if="metadata"><span class="font-weight-bold">SN:</span> <a target="_blank" rel="nofollow" :href="metadataUrl">{{ metadata.sn }}</a></div>
                                    <div class="mt-n1"><span class="font-weight-bold">{{ nft.token_id ? 'ID: ' : 'PREMINT ID:' }}</span><a v-if="nft.token_id || nft.premint_id" target="_blank" rel="nofollow" :href="explorerUrl">{{ nft.token_id ? `${nft.token_id}` : `${nft.premint_id}` }}</a></div>
                                    <div class="mt-n1 text-no-wrap" v-if="staticMetadata"><span class="font-weight-bold">CID:</span> <span class="cid-link">{{ staticMetadata.cid }}</span></div>
                                </div>
                                <div v-if="nft.token_id" class="text-caption">
                                    <span class="font-weight-bold">Owner:</span> <span class="font-weight-light">{{ owner.split('.').shift() }}</span>
                                </div>
                                <div class="text-caption mt-4 d-flex">
                                    <span class="mr-4 font-weight-bold">Current Price:</span>
                                    <div v-if="metadata && metadata.sale_conditions" class="d-flex align-center">
                                        <icon-base height="20" width="20" viewBox="0 0 180 225" icon-name="near">
                                            <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                        </icon-base><span class="text-body-2">{{ price | formatNearAmount }}</span>,
                                        <v-icon color="black" small class="ml-2">{{ mdiCurrencyUsd }}</v-icon><span class="text-body-2">{{ conversions.usd }}</span>
                                        <v-btn v-if="accountId !== owner" @click="$near.purchase(nft.token_id, price)" text small class="ml-2">Purchase</v-btn>
                                    </div>
                                    <div v-else class="text-uppercase">
                                        Not currently for sale.
                                    </div>
                                    <!--
                                    <v-btn text x-small v-if="!isSignedIn" @click="$near.signIn">
                                        <icon-base height="20" width="20" viewBox="0 0 180 225" icon-name="near" class="mr-2">
                                            <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                        </icon-base><span class="font-weight-dark text-uppercase mr-1">Sign In</span>
                                    </v-btn>
                                    -->
                                    <bnft-near-wallet-button shorten class="ml-4"></bnft-near-wallet-button>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-container>
                        <div>
                            <v-list-item-title v-if="username" class="text-h5 font-weight-regular mb-0">
                                {{ username.first }}<span class="font-weight-thin font-italic">({{ username.nickname }})</span> {{ username.last }}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="aliases && aliases.length" class="d-flex text-caption">Aka <div class="ml-2" v-html="aliases"></div>
                            </v-list-item-subtitle>
                        </div>
                    </v-container>
                </v-list-item-content>

                <v-sheet v-if="!$vuetify.breakpoint.mobile" id="bra-sheet" class="my-4 mr-2 rounded-lg" height="175" width="175" elevation="2">
                    <v-img :eager="eager" @click="imageClickHandler" id="bra-image" class="thumbs" height="175" width="175" :src="bra && bra.url"></v-img>
                </v-sheet>
                <v-sheet v-if="!$vuetify.breakpoint.mobile" id="tag-sheet" class="my-4 ml-2 rounded-lg" height="175" width="175" elevation="2">
                    <v-img :eager="eager" @click="imageClickHandler" id="tag-image" class="thumbs" height="175" width="175" :src="tag && tag.url"></v-img>
                </v-sheet>
            </v-list-item>
            <div class="d-flex justify-center flex-wrap">
                <v-sheet v-if="$vuetify.breakpoint.mobile" id="bra-sheet" class="my-4 mr-2 rounded-lg" elevation="2">
                    <v-img :eager="eager" @click="imageClickHandler" id="bra-image" class="thumbs" max-width="275" :src="bra && bra.url"></v-img>
                </v-sheet>
                <v-sheet v-if="$vuetify.breakpoint.mobile" id="tag-sheet" class="my-4 ml-2 rounded-lg" elevation="2">
                    <v-img :eager="eager" @click="imageClickHandler" id="tag-image" class="thumbs" max-width="275" :src="tag && tag.url"></v-img>
                </v-sheet>
            </div>
            <p id="description-text" @click="expandParagraph" class="ma-6 description-text text-left" :class="$vuetify.breakpoint.mobile ? 'mobile-paragraphs' : ''">
                {{ nft.description }}
            </p>
            <v-slide-group
                           v-if="nft.assets"
                           mandatory
                           v-model="slideGroup"
                           class="px-2"
                           :prev-icon="mdiChevronLeft"
                           :next-icon="mdiChevronRight">
                <v-slide-item class="mb-6"
                              v-for="(asset) of nft.assets.filter(asset => !asset.field.match(/bra|tag/))"
                              :key="asset.url"
                              v-slot="{ active, toggle }">
                    <v-card
                            :color="active ? 'black' : 'grey lighten-1'"
                            class="ma-2 rounded-lg"
                            height="300"
                            width="150">
                        <v-row
                               class="slide-group-row my-0"
                               align="center"
                               justify="center">
                            <v-scale-transition>
                                <v-img :eager="eager" class="thumbs" height="300" max-width="150" lazy-src="https://picsum.photos/id/497/1080/1080" :key="`${asset.gif}`"
                                       @click="(event, value) => imageClickHandler(event, value, toggle)"
                                       :src="asset.type === 'image/*' ? asset.url : asset.type === 'secret' ? `/everyday-basics-GJY1eAw6tn8-unsplash${/^((?!chrome|android).)*safari/i.test(userAgent) ? '.jpeg' : '.webp'}` : asset.gif"></v-img>
                            </v-scale-transition>
                        </v-row>
                    </v-card>
                </v-slide-item>
            </v-slide-group>
            <div id="lightgallery">
            </div>
            <v-btn v-if="$parent.$options.name !== 'TsNftSellPanel' && !example && !screenshot && !$route.name.match(/^branft$/)" text small plain class="d-flex ml-auto" @click="$emit('close')">close</v-btn>
        </v-card>
    </v-container>
</template>
<style>
.asset .v-messages {
    position: absolute;
}
.v-slide-group__content {
    justify-content: center;
}
.ts-nft a {
    text-decoration: none;
}
.v-list-item__subtitle .social-label {
    font-size: smaller;
    font-style: italic;
}
.description-text {
    font-family: "Allura";
    font-size: 1.5rem;
    white-space: pre-wrap;
}
.mobile .description-text {
    font-size: 1.3rem;
}
</style>
<style scoped>
.v-image {
    cursor: pointer;
}
.mobile-paragraphs {
    -webkit-line-clamp: 4;
}
.thumbnail:hover {
    transition-property: all;
    -webkit-transition-property: all;
    transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    transform: scale(1.5);
    z-index: 999;
}
.thumbs {
    border-radius: 8px;
}
.slide-group-row {
    height: 100%;
}
.cid-link {
    font-size: smaller;
}
</style>
<script>
const { VUE_APP_NEAR_NFT_CONTRACT_ID } = process.env;

import App from "../App.vue";
import BnftNearWalletButton from "./BnftNearWalletButton.vue";

import {
    mdiVideoAccount,
    mdiYoutube,
    mdiChevronLeft,
    mdiChevronRight,
    mdiCurrencyUsd,
} from "@mdi/js";
import gifshot from "gifshot";
import lightGallery from "lightgallery/lightgallery.min.js";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-video.css";
import { map } from "bluebird";
import { utils } from "near-api-js";

export default {
    name: "NFT",
    props: {
        premint_id: {
            type: String,
            required: true,
        },
        eager: Boolean,
        margin: String,
        data: Object,
        example: Object,
        position: String,
        screenshot: Boolean,
    },
    components: {
        BnftNearWalletButton,
        ...App.components,
    },
    filters: {},
    model: {
        event: "change",
    },
    data: function () {
        return {
            token: null,
            slideGroup: null,
            mdiYoutube,
            mdiChevronLeft,
            mdiChevronRight,
            mdiCurrencyUsd,
            mdiVideoAccount,
            nft: {
                description: null,
                bra: {
                    brand: null,
                    name: null,
                    size: {
                        band: null,
                        cup: null,
                    },
                },
                assets: [],
            },
            lightGallery: null,
            gifs: null,
            imagesLoaded: 0,
            screenshotDebounce: false,
            aliases: null,
            isSignedIn: false,
            metadata: null,
            listing: null,
            staticMetadata: null,
        };
    },
    computed: {
        wallet() {
            return this.$near.wallet[process.env.VUE_APP_NEAR_WISHLIST_CONTRACT_ID]
        },
        userAgent() {
            return window?.navigator?.userAgent
        },
        color() {
            return this.nft.bra.color
                ? JSON.parse(this.nft.bra.color).color
                : undefined;
        },
        screenshots() {
            return this.$store.state.screenshots;
        },
        username() {
            if (!this.nft.creator) return;
            const username = this.nft.creator.match(/(.*)\s\((.*)\)\s(.*)/);
            const first = username[1],
                firstPlural = username[1].endsWith("s")
                    ? `${username[1]}'`
                    : `${username[1]}'s`,
                last = username[3],
                nickname = username[2];
            return { first, firstPlural, last, nickname };
        },
        bra() {
            if (this.nft.assets && this.nft.assets.length > 0) {
                return this.nft.assets.find((asset) => asset.field === "bra");
            } else {
                return null;
            }
        },
        tag() {
            if (this.nft.assets && this.nft.assets.length > 0) {
                return this.nft.assets.find((asset) => asset.field === "tag");
            } else {
                return null;
            }
        },
        readyToRender() {
            return (
                this.explorerUrl ||
                (this.nft && this.nft.assets && this.nft.assets.length > 0)
            );
        },
        id() {
            const id = this.nft.token_id ? this.nft.token_id : "";
            return id;
        },
        explorerUrl(contractId = VUE_APP_NEAR_NFT_CONTRACT_ID) {
            const basePath = `accounts/${contractId}`;
            const transactionId =
                this.nft && this.nft.log && this.nft.log.transaction
                    ? this.nft.log.transaction.hash
                    : this.$route.query.transactionHashes;
            if (!transactionId) return this.$near.explorerUrl({ contractId, path: basePath });
            return this.$near.explorerUrl({ contractId, path: `${basePath}/transactions/${transactionId}` });
        },
        metadataUrl() {
            return this.nft && this.nft.token_id
                ? `https://${this.github}/${this.nft.token_id}.json`
                : "";
        },
        price() {
            return this.metadata && this.metadata.sale_conditions
                ? this.metadata.sale_conditions.sale_price
                : undefined;
        },
        conversions() {
            const USD =
                this.listing
                    ? this.listing.averageUSD
                    : undefined;
            if (!this.price || !USD) return {};
            return {
                usd: Number.parseFloat(
                    utils.format.formatNearAmount(this.price) * USD
                ).toFixed(0),
            };
        },
        owner() {
            const { nft } = this;
            return nft.blockchainData ? nft.blockchainData.owner_id : "";
        },
        accountId() {
            return this.isSignedIn ? this.wallet.getAccountId() : "";
        },
        tld() {
            return document.domain.match(/[^.]*.com/)[0];
        },
        github() {
            return process.env.NODE_ENV === "production"
                ? `github.${this.tld}`
                : `github-development.${this.tld}`;
        },
        updateCache() {
            return !!this.$route.query.updateCache;
        },
    },
    mounted() {
        const self = this;
        if (!this.example) {
            self.get();
        } else {
            self.nft = self.example;
            (async function () {
                await map(self.nft.videos, async (video) => {
                    const blob = await fetch(video.url)
                        .then((r) => r.blob())
                        .then((b) => URL.createObjectURL(b));
                    const update = {
                        type: "video/mp4",
                        url: video.url,
                        blob,
                        gif: null,
                        field: self.getAssetField(
                            self.premint_id,
                            video.filename
                        ),
                    };
                    const index = self.nft.assets.findIndex(
                        (asset) => asset.url === update.url
                    );
                    self.nft.assets[index] = update;
                });
                self.$set(self, "nft", self.nft);
                self.exampleGet();
            })();
        }
        (async function () {
            if (!self.wallet) return
            const isSignedIn = await self.wallet.isSignedIn();
            self.$set(self, "isSignedIn", isSignedIn);
            if (isSignedIn)
                self.wallet = await self.$near.getWalletConnection();
        })();
        if (this.$route.query.errorCode)
            this.$root.$emit(
                this.$route.query.errorCode,
                decodeURIComponent(this.$route.query.errorMessage)
            );
    },
    watch: {
        premint_id: function (curVal, newVal) {
            if (curVal !== newVal && !this.example) this.get();
            if (this.example) this.exampleGet();
        },
        data(value) {
            const nft = { ...this.data, ...value };
            this.$set(this, "nft", nft);
        },
    },
    methods: {
        expandParagraph(event) {
            if (event.target.classList.contains("mobile-paragraphs"))
                event.target.classList.remove("mobile-paragraphs");
            else event.target.classList.add("mobile-paragraphs");
        },
        lgDynamicEl() {
            const config =
                this.nft.assets &&
                this.nft.assets
                    .filter((asset) => asset.type !== "secret")
                    .filter((asset) => asset.url)
                    .map((asset) => {
                        let lightgalleryObject = {
                            url: asset.url,
                            subHtml: `<h4>${asset.field}</h4>`,
                        };
                        if (asset.type.match(/image\/.*/)) {
                            lightgalleryObject = {
                                src: asset.url,
                                thumb: asset.url,
                                ...lightgalleryObject,
                            };
                        } else if (asset.type.match(/video\/.*/)) {
                            lightgalleryObject = {
                                video: {
                                    source: [
                                        { src: asset.blob, type: asset.type },
                                    ],
                                    src: asset.url,
                                    type: asset.type,
                                },
                                thumb: asset.gif,
                                ...lightgalleryObject,
                            };
                        }
                        return lightgalleryObject;
                    });
            return config;
        },
        getAssetField(premint_id, filename) {
            const regex = new RegExp(`${premint_id}_([^-]*)-`);
            const field = filename.match(regex)[1];
            return field;
        },
        lgOnInit() {},
        lgOnBeforeSlide() {},
        iconToUrl(icon, options = { width: 24, height: 24 }) {
            const { width, height } = options;
            const path = icon;
            const base64 = btoa(
                `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="175" viewBox="0 0 ${height} ${width}" role="img" aria-hidden="true" class="v-icon__svg"><path d="${path}"></path></svg>`
            );
            const url = `data:image/svg+xml;base64,${base64}`;
            return url;
        },
        createGifs() {
            const self = this;
            const videos =
                self.nft.assets &&
                self.nft.assets
                    .filter(
                        (asset) => asset.type.match(/video\/.*/) && !asset.gif
                    )
                    .map((video) => video.blob);
            if (videos.length <= 0) {
                self.$forceUpdate();
                return;
            }
            gifshot.createGIF(
                {
                    video: videos,
                    interval: 0.5,
                    offset: 3,
                    numFrames: 10,
                },
                function (obj) {
                    const match = obj.videoElement.src.match(/\/s\/([^\/]*)\//);
                    const id = match ? match[1] : undefined;
                    if (!obj.error) {
                        const index = self.nft.assets.findIndex((asset) =>
                            id
                                ? asset.url.match(id)
                                : asset.blob &&
                                  asset.blob.match(obj.videoElement.src)
                        );
                        self.$set(self.nft.assets[index], "gif", obj.image);
                        /** vuex-persistedstate.es.js:2 Uncaught DOMException: Failed to execute 'setItem' on 'Storage': Setting the value of 'vuex' exceeded the quota.
                        self.$store.commit({
                            type: "set",
                            [`gifs.${self.nft.assets[index].url}`]: obj.image,
                        }); */
                        self.$forceUpdate();
                    }
                }
            );
        },
        imageClickHandler(event, value, toggle) {
            value;
            let index = 0;
            if (toggle) toggle();
            if (event && !event.currentTarget.id.match(/tag-image|bra-image/)) {
                index = this.slideGroup + 2;
            }
            if (
                this.nft.assets[index].type === "secret" ||
                !this.lightGallery
            ) {
                return;
            }
            this.lightGallery.refresh(this.lgDynamicEl());
            this.lightGallery.openGallery(index > -1 ? index : 0);
        },
        async exampleGet() {
            const self = this;
            const htmlFormattedAliases = await self.$backend.getCreatorAliases(
                this.nft.creator
            );
            if (htmlFormattedAliases)
                this.$set(this, "aliases", htmlFormattedAliases.join(", "));
            await self.createGifs();
            self.lightGallery = lightGallery(
                document.getElementById("lightgallery"),
                {
                    plugins: [lgZoom, lgThumbnail, lgVideo],
                    dynamic: true,
                    dynamicEl: self.lgDynamicEl(),
                    currentPagerPosition: "middle",
                    thumbnail: true,
                    autoplayVideoOnSlide: true,
                }
            );
            self.listing = await self.$backend.getLatestNearListing();
            const metadata = await self.$near.getNftMetadata(self.id);
            self.$set(self, "metadata", metadata);
            self.$emit("change", self);
        },
        get() {
            const self = this;
            self.$backend
                .getNft(self.premint_id, self.updateCache)
                .then(async (response) => {
                    self.$set(self, "nft", response);
                    self.getStaticMetadata(self.id);
                    const htmlFormattedAliases =
                        await self.$backend.getCreatorAliases(self.nft.creator);
                    if (
                        htmlFormattedAliases &&
                        !(htmlFormattedAliases instanceof Error)
                    )
                        self.$set(
                            self,
                            "aliases",
                            htmlFormattedAliases.join(", ")
                        );
                    self.$store.commit({
                        type: "set",
                        screenshots: response.screenshots,
                    });
                    self.$set(
                        self.nft,
                        "assets",
                        response.photos.map((photo) => ({
                            type: "image/*",
                            url: /^((?!chrome|android).)*safari/i.test(self.userAgent) ? photo.url.replace('.webp', '.jpeg') : photo.url,
                            field: self.getAssetField(
                                self.premint_id,
                                photo.filename
                            ),
                        }))
                    );
                    self.nft.assets = self.nft.assets.concat(
                        await new Promise((resolve) => {
                            const mapped = map(
                                response.videos,
                                async (video) => {
                                    const blob = await fetch(video.url)
                                        .then((r) => r.blob())
                                        .then((b) => URL.createObjectURL(b));
                                    return {
                                        type: "video/mp4",
                                        url: video.url,
                                        blob,
                                        gif: this.$store.state[
                                            `gifs.${video.url}`
                                        ]
                                            ? this.$store.state[
                                                  `gifs.${video.url}`
                                              ]
                                            : null,
                                        field: self.getAssetField(
                                            self.premint_id,
                                            video.filename
                                        ),
                                    };
                                }
                            );
                            resolve(mapped);
                        })
                    );
                    self.nft.assets = self.nft.assets.concat(
                        response.secrets.map((secret) => ({
                            type: "secret",
                            url: secret.url,
                            field: self.getAssetField(
                                self.premint_id,
                                secret.filename
                            ),
                        }))
                    );
                    await self.createGifs();
                    self.lightGallery = lightGallery(
                        document.getElementById("lightgallery"),
                        {
                            plugins: [lgZoom, lgThumbnail, lgVideo],
                            dynamic: true,
                            dynamicEl: self.lgDynamicEl(),
                            currentPagerPosition: "middle",
                            thumbnail: true,
                            autoplayVideoOnSlide: true,
                        }
                    );
                    self.listing = await self.$backend.getLatestNearListing();
                    const metadata = await self.$near.getNftMetadata(self.id);
                    self.$set(self, "metadata", metadata);
                    self.$emit("change", self);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async getStaticMetadata(token_id) {
            const response = await fetch(
                `https://${this.github}/${token_id}.json`
            );
            if (!response.ok) throw new Error(response);
            const json = await response.json();
            this.staticMetadata = json;
        },
        async walletDisconnect() {
            await this.$near.signOut({ contractIds: [VUE_APP_NEAR_NFT_CONTRACT_ID] });
        },
    },
};
</script>
